export const moveDefaultCollectionFiledsToEndAndSort = (fields) => {
  const defaultFileds = [];
  const customfields = [];
  fields.map((element) => {
    if (
      ['uuid', 'createdAt', 'updatedAt', 'createdBy', 'updatedBy', 'version'].includes(
        element.fieldName,
      )
    ) {
      defaultFileds.push(element);
    } else if (element.fieldName === 'isDeleted') {
    } else {
      customfields.push(element);
    }
  });
  return [
    ...customfields.sort(dynamicSort('fieldName')),
    ...defaultFileds.sort(dynamicSort('fieldName')),
  ];
};

export const dynamicSort = (property) => {
  return (a, b) => {
    let result = 0;
    if (a[property] && b[property] && a[property] !== 'undefined' && b[property] !== 'undefined') {
      if (typeof a[property] === 'number' || typeof b[property] === 'number') {
        result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      } else {
        result =
          a[property].toLowerCase() < b[property].toLowerCase()
            ? -1
            : a[property].toLowerCase() > b[property].toLowerCase()
            ? 1
            : 0;
      }
    } else {
      result = 0;
    }

    return result;
  };
};

export const snakeCaseToTitleCase = (str, checkForUnderscore = false) => {
  if (!str) return str;
  if (typeof str === 'string' && !checkForUnderscore) {
    return str
      .toLowerCase()
      .split('_')
      .map((word) => {
        return word.replace(word[0], word[0].toUpperCase());
      })
      .join(' ');
  }
  return str;
};

export const filterByKey = (array, key, value) => {
  if (!array || !key) {
    return null;
  }
  return array.find((item) => item[key] === value);
};

export const sortAndCreateOptions = (fields) => {
  const fieldOptions = fields.sort(dynamicSort('fieldName')).map((item) => {
    return { value: item.fieldName, label: item.fieldTitle.en };
  });
  return fieldOptions;
};
